<template>
    <EuiBlock   class="w-auto ml-0" title="Résultat">
      <EuiLoader :is-loading="loadNextLogs"/>
      <span
          id="searchBlock"
          style="position:absolute;top:0px;"
          :style="{height:freeTimelineHeight+'px'}"/>
      <EuiHeading v-if="getterIsLoading " :level="2">En cours de chargement</EuiHeading>
      <EuiHeading :level="3" blod class="mt-2" v-else-if="getterLogs.messages.length === 0">
        Aucun résultat
      </EuiHeading>
      <div v-else class="flex">
        <timelineNavigation
            :content="mixinsGroupByDateLogs"
            :isActivateButtonMoreLogs="getterLogs.messages.length < getterLogs.total_results"
            @get-more-logs="loadNextResults"/>
        <div class="w-full listResultLogs"
           :class="{'listResultLogs__with_timelineFixed':this.getterTimelineFixed}">
          <EuiHeading :level="3" bold class="mt-2">
            Logs chargés: {{ getterLogs.messages.length }} / total: {{ getterLogs.total_results}}
          </EuiHeading>
          <EuiCard class="mt-4" v-for="(logs, date) in mixinsGroupByDateLogs" :key="date" style="">
            <span :id="date"/>
            <EuiBlock class="ml-0" :title="`Logs du ${date}`" >
              <div class="p-2" v-for="(log, index) in logs" :key="index">
                <log-card :content="log"/>
              </div>
            </EuiBlock>
          </EuiCard>
        </div>
      </div>
      <intersection-observer
          v-if="getterLogs.total_results > 150"
          sentinal-name="infiniteScrollSentinal"
          @on-intersection-element="loadNextResults"
          :timer=500
          style="position:absolute;bottom:0px;height:500px;"/>
    </EuiBlock>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import logCard from '@/components/logs/logCard.vue';
import timelineNavigation from '@/components/logs/timelineNavigation.vue';
import IntersectionObserver from '@/observer/intersectionObserver.vue';
import groupBy from '@/mixins/groupBy';
import dates from '@/mixins/dates';

/*
This component displays the logs result
 */
export default {
  name: 'components.logs.result',
  mixins: [groupBy, dates],
  components: {
    logCard,
    timelineNavigation,
    IntersectionObserver,
  },
  data() {
    return {
      isTimelineFixed: false,
    };
  },
  props: {
    freeTimelineHeight: {
      type: Number,
      default: 470,
    },
    loadNextLogs: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isTimelineFixed(value) {
      this.storeSetTimelineFixed(value);
    },
    getterLogs() {
      this.initObserver();
    },
  },
  computed: {
    ...mapGetters({
      getterLogs: 'logs/result',
      getterTimelineFixed: 'application/timelineFixed',
      getterIsNavigationMini: 'application/isMiniVariant',
      getterIsLaunch: 'application/isLaunch',
      getterIsLoading: 'application/isLoading',
    }),
  },
  methods: {
    ...mapActions({
      storeSetTimelineFixed: 'application/setTimelineFixed',
    }),
    initObserver() {
      if (this.getterIsLaunch && this.getterLogs.messages.length > 0) {
        const sentinal = document.getElementById('searchBlock');
        const handler = (entries) => {
          if (entries[0].isIntersecting) {
            this.isTimelineFixed = false;
          } else {
            this.isTimelineFixed = true;
          }
        };
        const observer = new window.IntersectionObserver(handler, {
          threshold: 0,
        });
        observer.observe(sentinal);
      }
    },
    loadNextResults() {
      this.$emit('load-next-result');
    },
  },
};
</script>
